import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { API_CONFIG, buildApiUrl } from '../../common/api';
import { trackPartnerEvent } from '../hooks/useCandidaturaAnalytics';

/**
 * Form iscrizione newsletter / waitlist lancio.
 * @param {{ sorgente?: string, interesse?: string, compact?: boolean, onSuccess?: () => void }} props
 */
export default function NewsletterSignup({
  sorgente = 'home',
  interesse = 'catalogo',
  compact = false,
  onSuccess,
}) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!email.trim()) {
      setError("L'email è obbligatoria");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Inserisci un\'email valida');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.NEWSLETTER), {
        method: 'POST',
        headers: API_CONFIG.DEFAULT_HEADERS,
        body: JSON.stringify({ email: email.trim(), sorgente, interesse }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok && res.status !== 200) {
        const msg = data.message
          || data.errors?.email?.[0]
          || 'Errore durante l\'iscrizione. Riprova più tardi.';
        throw new Error(msg);
      }
      setMessage(data.message || 'Iscrizione completata.');
      setDone(true);
      trackPartnerEvent('newsletter_subscribe', { sorgente, interesse, already: !!data.already_subscribed });
      onSuccess?.();
    } catch (err) {
      setError(err.message || 'Errore durante l\'iscrizione.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className={compact ? 'text-sm text-[#7a4a1f]' : 'text-center'}>
        <p className={compact ? '' : 'text-lg font-semibold text-[#c78244] mb-2'}>
          {message || 'Grazie! Ti avviseremo al lancio.'}
        </p>
        {!compact && (
          <p className="text-gray-600 text-sm">
            Controlla anche la cartella spam. Puoi continuare a esplorare il{' '}
            <Link to="/catalogo" className="text-[#c78244] underline">catalogo</Link>.
          </p>
        )}
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? 'space-y-2' : 'space-y-3'}>
      {!compact && (
        <p className="text-sm text-gray-600">
          Avvisami quando potrò ordinare le eccellenze alimentari selezionate.
        </p>
      )}
      <div className={compact ? 'flex flex-col sm:flex-row gap-2' : 'space-y-2'}>
        <input
          type="email"
          placeholder="La tua email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (error) setError('');
          }}
          className={`w-full border rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 ${
            error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-[#c78244]'
          }`}
          disabled={loading}
          autoComplete="email"
        />
        <motion.button
          type="submit"
          disabled={loading}
          whileHover={{ scale: loading ? 1 : 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`mang-gradient text-white font-bold rounded-xl px-6 py-2.5 disabled:opacity-60 whitespace-nowrap ${
            compact ? 'sm:w-auto w-full' : 'w-full'
          }`}
        >
          {loading ? 'Invio…' : 'Avvisami al lancio'}
        </motion.button>
      </div>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      <p className="text-xs text-gray-400">
        Iscrivendoti accetti la{' '}
        <Link to="/privacy" className="underline hover:text-[#c78244]">Privacy Policy</Link>
        {' '}e i{' '}
        <Link to="/termini" className="underline hover:text-[#c78244]">Termini</Link>.
      </p>
    </form>
  );
}
